export default "__VITE_ASSET__168a760c__"